import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            特色优势
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            吃瓜在线为你带来更优质的吃瓜视频观看体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="group relative p-6 rounded-xl bg-background-100 border border-background-200 hover:border-primary-200 transition-all duration-200 text-center"
            >
              <span className="inline-flex w-14 h-14 md:w-16 md:h-16 items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-200">
                <i className={`${item.icon} text-2xl md:text-3xl`}></i>
              </span>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}